import { getApiUrl } from '@/shared/utils/helpers';
import Vue from 'vue';
export async function listExcludedCnpjs(params) {
    return await Vue.axios.get(`${getApiUrl('v4')}/excluded_cnpjs/list?page=${params.page}&search=${params.search}`);
}
export async function addExcludedCnpjs(cnpjs) {
    return await Vue.axios.post(`${getApiUrl('v4')}/excluded_cnpjs/add`, {
        cnpjs,
    });
}
export async function removeExcludedCnpjs(cnpjs) {
    return await Vue.axios.post(`${getApiUrl('v4')}/excluded_cnpjs/remove`, {
        cnpjs,
    });
}
export async function cleanExcludedCnpjs() {
    return await Vue.axios.post(`${getApiUrl('v4')}/excluded_cnpjs/clean`);
}
